import { render, staticRenderFns } from "./Disposition.vue?vue&type=template&id=653f16b0&scoped=true&"
import script from "./Disposition.vue?vue&type=script&lang=js&"
export * from "./Disposition.vue?vue&type=script&lang=js&"
import style0 from "./Disposition.vue?vue&type=style&index=0&id=653f16b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f16b0",
  null
  
)

export default component.exports